import { jsx as _jsx } from "react/jsx-runtime";
import { useTheme } from 'styled-components';
import { useSubscribe } from '@/js/libs/observable';
import { OnHover } from '../../Components/OnHover';
import { Button } from '../../Controls/Button';
import { Tooltip } from '../../Feedback/Tooltip';
import Icons from '../Icons';
export const UnavailableIcon = ({ tooltip, onClick, pending$, }) => {
    const theme = useTheme();
    const pending = useSubscribe((ctx) => (pending$ ? ctx.spy(pending$) : false));
    return (_jsx(OnHover, { children: (hovered) => (_jsx(Tooltip, { tooltip: tooltip, placement: 'top', ContainerComponent: Button, containerComponentProps: { ghost: true, onClick, isLoading: pending, disabled: pending }, children: _jsx(Icons.TemporaryUnavailable, { filled: hovered, size: 24, color: theme.colors.link70 }) })) }));
};
